<div class="col-12 col-md-8 col-lg-12 col-xl-7 ps-0 pe-0">
  <div class="card">
    <div
      class="files-dropzone p-1 mb-2"
      #drop
      ngx-dropzone
      (change)="onSelect($event)"
      [disableClick]="true"
      accept="*"
    >
      <div class="row w-100">
        <div class="col-md-5 d-flex align-items-center ps-0">
          <h3 class="card-title">{{ 'address.directory' | translate }}</h3>
        </div>
        <div class="col-md-7 pe-0 d-flex justify-content-end">
          <div>
            <btn
              [label]="'upload'"
              [icon]="'far-file-import'"
              [title]="'upload' | translate"
              (onEvent)="drop.showFileSelector()"
              [classes]="['btn-third', 'btn-sm', 'me-2']"
              [dataCyAttribute]="'show-file-selector'"
            ></btn>
          </div>
        </div>
      </div>
    </div>
    @for (file of productDetailService.product.files; track file) {
      <div class="d-flex mt-2 flex-gap-5 padding-left-2 padding-right-2">
        <div class="col flex-gap-5">
          @if (file.mimeType?.includes('image/')) {
            <i class="fa fa-file-image" title="Image"></i>
          }
          @if (
            file.mimeType?.includes('text/') ||
            file.mimeType?.includes('/msword') ||
            file.mimeType?.includes('wordprocessingml')
          ) {
            <i class="fa fa-file-text" title="Text"></i>
          }
          @if (file.mimeType?.includes('application/pdf')) {
            <i class="fa fa-file-pdf" title="Pdf"></i>
          }
          @if (file.mimeType?.includes('spreadsheet') || file.mimeType?.includes('ms-excel')) {
            <i class="fa fa-file-excel" title="Excel"></i>
          }
          @if (unknownType(file.mimeType)) {
            <i class="fa fa-file" title="File"></i>
          }
          <a class="link" href="{{ file.url }}" target="_blank" data-cy="file-url">
            {{ file.originalFilename || file.text || 'file' }}
          </a>
        </div>
        <div class="me-2">{{ file.size / 1024 | number: '1.0-2' | replaceCommaToDot }}&nbsp;kB</div>
        <btn
          [title]="'delete' | translate"
          [icon]="'far-trash-alt'"
          [classes]="['btn-trash', 'btn-sm', 'float-right']"
          (click)="removeFile(file)"
          [dataCyAttribute]="'product-file-delete'"
        ></btn>
      </div>
    }
  </div>
</div>
